import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { getExpandedItems } from "../../utils/outbound-labels-utils";
import { StringListCell } from "../cells/string-list-cell";

const catalogEntry = fgColumnEntries["product-variant"];

export const ProductVariantColumn: Column2<FulfillmentGroupData> = {
  key: catalogEntry.key,
  title: catalogEntry.title,
  alignment: ColumnAlignment.LEFT,
  renderNormalCell: ({ row }) => {
    const productVariants = row.items.map((item) => item.variantTitle);
    return <StringListCell displayName="variant" strings={productVariants} />;
  },
  width: catalogEntry.defaultWidth,
  sort: catalogEntry.sortDirection,
  renderExpandedCell: ({
    row,
    expansionIndex,
  }: {
    row: FulfillmentGroupData;
    expansionIndex: number;
  }) => {
    const variantTitle = getExpandedItems(row)?.[expansionIndex]?.variantTitle;
    return <RedoTableTextCell text={variantTitle ?? ""} />;
  },
};
